import { isApolloError } from '@apollo/client'
import axios from 'axios'

export function getStatusFromApiError(error: unknown) {
  if (axios.isAxiosError(error)) return error.response?.status
  if (
    error instanceof Error &&
    isApolloError(error) &&
    error.networkError &&
    'statusCode' in error.networkError
  )
    return error.networkError.statusCode
}
